import React, { useRef } from "react";
import openai from "../utils/openai";
import { searchMovies } from "../utils/searchmovie";
import { useDispatch } from "react-redux";
import { addMovieResults } from "../store/searchResSlice";

const SearchBar = () => {
  const search = useRef("");
  const dispatch = useDispatch();
  const handleSearch = async (e) => {
    e.preventDefault();
    const searchText = search.current.value;
    const gptQuery = `Act as a movie recommendation system and suggest some movies for the query: ${searchText}. The output should contain only 5 movie names, comma separated and no bullets or formtting should be applied. Example must look like this: Deadpool, Avengers, Wonder Woman, Iron Man, Hulk. If for some reason you can not recommend any movies based on the query return an empty string.`;
    const gptResults = await openai.chat.completions.create({
      messages: [{ role: "user", content: gptQuery }],
      model: "gpt-3.5-turbo",
    });
    const names = gptResults.choices?.[0]?.message?.content;
    try {
      const results = await searchMovies(names);
      dispatch(addMovieResults(results));
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <form className="bg-black flex justify-center p-6 rounded-md bg-opacity-50">
        <input
          className="m-2 p-2 w-3/4 rounded-md focus:outline-current text-xs md:text-base lg:text-lg"
          ref={search}
          type="text"
          placeholder="What would you like to watch today?"
        />
        <button
          className="m-2 p-2 min-w-20 lg:min-w-24 bg-red-600 text-white rounded-md outline-current"
          onClick={(e) => {
            handleSearch(e);
          }}
        >
          Search
        </button>
      </form>
    </>
  );
};

export default SearchBar;
